// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { Link } from 'react-router-dom'
import dpImage from 'images/data-products_white.png'

const DataProducts = () => (
  <Link
    className={'home-cta'}
    to={'/data-products'}
    id={'home-nav-dataproducts'}>
    <img
      className={'home-cta-icon'}
      src={dpImage}
      alt={'DATA PRODUCTS'} />
    {'DATA PRODUCTS'}
  </Link>
)

export default DataProducts
